
























































import { Component, Vue } from 'vue-property-decorator';
import { getQueryArray, getPlatform } from '@/utils/common';
import { Logger } from '@ddmc/logger';
import { UNENCODE_LIST } from '@/constants';
@Component({
  name: 'Mobile',
  components: {},
})
export default class extends Vue {
  beianUrl =
    'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502004838';
  beianmiit = 'http://beian.miit.gov.cn';
  ddmcUrl = 'https://tools.ddxq.mobi/#/d/andddmc';
  appUrl = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.yaya.zone';
  logger = new Logger({});
  wxLinkUrl = 'pages/mainPackage/home/home';
  appid = 'wx1e113254eda17715';
  wxQuery = '';
  startTime: any = null;
  remainingTime = 6;
  timer: any = null;
  routerWxFlag = true;
  downClick() {
    let time = new Date().getTime();
    let platformBoo = this.getPlatform();
    let url = this.appUrl;
    if (platformBoo.isiOS) {
      url = 'https://itunes.apple.com/cn/app/id768082524?mt=8';
    } else if (location.href.indexOf('?channel=bdtg') != -1) {
      url = 'https://img.ddimg.mobi/叮咚买菜.apk' + '?t=' + time;
    }
    this.setLog({
      event_id: '2645',
      act: {
        act_type: 'click',
        page_id: 'downloadPage',
        module_id: 'download',
        component_id: 'btn',
        path: '/btn',
      },
    });
    location.href = url; //第三方网址崩溃的情况 需要考虑方案
  }
  downWxClick() {
    const url = `weixin://dl/business/?appid=${this.appid}&path=${this.wxLinkUrl}&query=${this.wxQuery}&env_version=release`;
    this.setLog({
      event_id: '5778',
      act: {
        act_type: 'click',
        page_id: 'downloadPage',
        module_id: 'download',
        component_id: 'btn_wechat',
        path: '/btn_wechat',
      },
    });
    console.log(url);
    location.href = url;
  }
  getPlatform() {
    let u = navigator.userAgent;
    let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    return {
      isAndroid: isAndroid,
      isiOS: isiOS,
    };
  }
  // 判断是否为内嵌webview
  customBrowserVersion() {
    let ua = navigator.userAgent.toLowerCase();
    let isSafari =
      ua.indexOf('safari') !== -1 ||
      ua.indexOf('sogoumobilebrowser') !== -1 ||
      ua.indexOf('mqqbrowser') !== -1 ||
      ua.indexOf('quark') !== -1 ||
      ua.indexOf('ucbrowser') !== -1 ||
      ua.indexOf('baiduboxapp') !== -1;
    return isSafari;
  }
  openApp() {
    let $originUrl = decodeURIComponent(location.href);
    let str = location.pathname.substring(0, 14);
    if (str === '/mc/ddxq:/ddmc') {
      $originUrl = $originUrl.replace('/mc/ddxq:/ddmc', '/mc/ddxq://ddmc');
    }
    let $index = $originUrl.indexOf('ddxq://');
    let ddxqLen = $originUrl.match(/ddxq:\/\//g);
    let newUrl = $originUrl.substring($index);
    let pathNameVal = location.pathname;
    const searchParams = location.search;
    let isIosFlag = this.getPlatform();
    let isSafariFlag = this.customBrowserVersion();
    if (newUrl.indexOf('wxPage') !== -1) {
      // ddxq://web?url=11111111&source=12345&wxPage=/pages/productPackage/productDetail/productDetail?product_id=123
      // 获取 app url 和 wx url 通过wxPage
      const index = newUrl.indexOf('wxPage');
      const wxUrl = newUrl.substring(index + 7, newUrl.length);
      if (wxUrl) {
        this.wxLinkUrl = wxUrl.substring(1, wxUrl.length);
        this.wxQuery = '';
      }
      if (wxUrl && wxUrl.indexOf('?') !== -1) {
        // 获取 wx url query
        const queryIndex = wxUrl.indexOf('?');
        this.wxLinkUrl = wxUrl.substring(1, queryIndex);
        const url = wxUrl.substring(queryIndex + 1, wxUrl.length);
        this.wxQuery = encodeURIComponent(url);
        // 如果为webview页面单独处理
        // let encodeLink = encodeURIComponent(url.substring(4, url.length));
        // this.wxQuery = encodeURIComponent(`src=${encodeLink}`);
      }
    }
    if (newUrl && ddxqLen && ddxqLen.length == 1) {
      // 有ddxq链接并且ddxq只能出现一个
      const encodeValue = this.encodeUrlData(newUrl);
      console.log(encodeValue);
      // 如果是app内webView && ios 则不跳转
      if (isIosFlag.isiOS && !isSafariFlag) {
        console.log('app内webView');
      } else {
        location.href = encodeValue;
      }
    }
  }

  /**
   * 将 url 的 value 部分进行编码的方法
   * 思路： 1.先判断 url 中有没有带参数，如果没有则不需要编码直接扔回去；在不编码的白名单中，直接原封不动扔回去
   *       2.如果带有参数，再判断参数中是否有嵌套的 url 参数，这里只考虑有一层嵌套的情况
   *       3.如果有嵌套的 url 参数，则根据 ? 把参数分成前后两部分，同时记录 ? 所在的索引，否则直接根据 & 分割
   *       4.经过上一步后得到一个包含所有 query 参数的数组，遍历数组将 value 部分编码，根据索引拼接 ? 或 &，如果是最后一个元素则不拼接
   */
  encodeUrlData(newUrl) {
    // 'https://www.100.me/mc/ddxq://coupon/list?url=60b9f36a4fb797921b8c0d11?a=1&b=1&c=1';
    const index = newUrl.indexOf('?');
    if (index === -1) {
      // 没有问号的情况，说明没有 query 传参数，不需要转码，直接扔回去
      return newUrl;
    }
    for (const unencodeItem of UNENCODE_LIST) {
      if (newUrl.includes(unencodeItem)) {
        // 在白名单里面的不 encode 直接原封不动带回去
        const schemeUrl = location.href;
        const schemeIndex = schemeUrl.indexOf('ddxq://');
        const fullUrl = schemeUrl.substring(schemeIndex);
        return fullUrl;
      }
    }
    const query = newUrl.substring(index + 1);
    const baseUrl = newUrl.substring(0, index + 1);
    let vars;
    let questionIndex = -1;
    // 判断是否还有嵌套的 url
    if (query.indexOf('?') !== -1) {
      // 如果还有问号，则根据问号分割，将 query 参数都放到一个数组里面
      const [paramsLeft, paramsRight] = query.split('?');
      const paramsLeftArr = paramsLeft.split('&');
      // 得到一个新数组，都是 query 传参
      vars = [...paramsLeftArr, ...paramsRight.split('&')];
      // 记录问号的索引
      questionIndex = paramsLeftArr.length - 1;
      // console.log('questionIndex: ', questionIndex);
    } else {
      // 没有问号走以前的逻辑
      vars = query.split('&');
    }
    let endocodeUrlValue = baseUrl;
    for (let i = 0; i < vars.length; i++) {
      const [key, value] = vars[i].split('=');
      // 判断是否是最后一个参数 是则不拼接 否则用 & 拼接
      const isLast = vars[i + 1] ? '&' : '';
      // 拼接分割符
      const separator = questionIndex === i ? encodeURIComponent('?') : isLast;
      endocodeUrlValue += `${key}=${encodeURIComponent(value)}${separator}`;
    }
    return endocodeUrlValue;
  }
  getQueryParam(param) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  }
  setLog(logObj: any) {
    const obj: any = getQueryArray();
    const source = getPlatform().source;
    obj.platform = source;
    obj.ip = 'test12345678';
    if (obj.op_channel || obj.channel) {
      obj.s = obj.op_channel || obj.channel;
    }
    const params = {
      time: new Date().getTime(),
      os: 3,
      event_id: logObj.event_id,
      app_version: '1.1.1',
      app_id: 'official_website',
      event_version: 0,
      act: logObj.act,
      properties: {
        ...obj,
      },
    };
    this.logger.collect(params);
  }
  startListening() {
    this.startTime = new Date();
    this.timer = setInterval(() => {
      this.updateRemainingTime();
    }, 1000);
  }
  stopListening() {
    clearInterval(this.timer);
  }
  updateRemainingTime() {
    const currentTime = new Date();
    const timeElapsed = ((currentTime as any) - this.startTime) / 1000; // 转换为秒
    this.remainingTime = Math.max(this.remainingTime - timeElapsed, 0);
    if (this.remainingTime === 0) {
      this.stopListening();
      if (this.routerWxFlag) {
        this.downWxClick();
      }
    }
  }
  created() {
    this.setLog({
      //曝光
      event_id: '2644',
      act: {
        act_type: 'exposure',
        page_id: 'downloadPage',
        module_id: 'no_m',
        component_id: 'no_c',
        path: '/mc',
      },
    });
    this.openApp();
    this.startListening();
  }
  mounted() {
    // 兼容安卓跳转后台问题
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.stopListening();
        this.routerWxFlag = false;
      }
    });
  }
  beforeDestroy() {
    this.stopListening();
  }
}
